import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCKThq4jskGrkvTBOaIFlXNye-3Z1PLXSU",
  authDomain: "slatevault.firebaseapp.com",
  projectId: "slatevault",
  storageBucket: "slatevault.firebasestorage.app",
  messagingSenderId: "974300771479",
  appId: "1:974300771479:web:87b1a7c3779e01fff2a5d2",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
